










































import {Component, Emit, Prop} from "vue-property-decorator";
import abpbase from "@/lib/abpbase";
import SectionLayout from "@/layouts/sectionLayout.vue";
import VWangEditor from "@/components/v-wangEditor.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import PrimaryPage from "@/layouts/primaryPage.vue";
import keywordCard from "@/layouts/keywordCard.vue";
import ajax from "@/lib/ajax";

@Component({
  name: 'askQuestion',
  components: {PrimaryPage, VWangEditor, SectionLayout, keywordCard}
})
export default class askQuestion extends abpbase {
  @Prop({type: String, default: ''}) queryParams: string;
  keywords: string = '';
  form;

  //是否已经提交
  isSubmit: boolean = false;

  hotkeys: string = "";

  defRoutes = [{
    path: 'QA',
    breadcrumbName: 'Q & A'
  }];

  keywordsChanged(e) {
    let titleVal = e.target.value.trim();
    this.hotkeys = titleVal;
    this.form.setFieldsValue({'title': titleVal});
    // this.$nextTick(() => {
    //     this.form.setFieldsValue({'title': this.hotkeys});
    // });
  }

  //显示
  show() {
    this.form.resetFields();
  }

  //表单提交
  handleSubmit(e) {
    e.preventDefault();
    this.form.validateFields((err, values) => {
      if (!err) {
        values.title = values.title.trim();
        this.submitForm(values);
      }
    });
  }

  // 表单验证
  formValidator(rule, value, callback) {
    let {field, fullField, type} = rule;
    switch (field) {
      case 'title':
        if (value) {
          let newVal = value.trim();
          if (newVal.length < 2) {
            callback(new Error("请输入您的问题（2-50个字）"));
          } else if (/<[^>]+>/gim.test(value)) {
            callback(new Error("标题不能包含html标签"))
          } else if (/&/gim.test(value)) {
            callback(new Error("标题不能包含&符"))
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入您的问题"));
        }
        break;
      case 'content':
        if (!value || value === '<p><br></p>') {
          callback(new Error("请输入内容"));
        } else {
          callback();
        }
        break;
      default:
        callback();
        break;
    }
  }

  //提交
  submitForm(formData: { title: string, content: string }) {
    this.isSubmit = true;
    ajaxHelperInstance.postMyQ('web/question/add', formData, this).then((res) => {
      let {status, data} = res;
      if (status === 200 && data) {
        const {message, errno} = data;
        if (errno === 0) {
          this.$message.success(message);
          this.handleSubmitSuccess();
        } else {
          this.$message.error(message);
        }
      }
    }).finally(() => {
      this.isSubmit = false;
    });
  }

  beforeCreate() {
    this.form = this.$form.createForm(this);
  }

  //关键字搜索
  handleSearch(keywords: string = '') {
    this.keywords = keywords;
    this.showTabList();
  }

  //显示列表页
  showTabList() {
    let queryParams = JSON.stringify({keywords: this.keywords});
    this.switchRouting('QA', {
      queryParams: queryParams
    });
  }

  //提交成功
  // @Emit('success')
  handleSubmitSuccess() {
    this.showTabList();
  }

  mounted() {
    try {
      let obj = JSON.parse(this.queryParams);
      if (obj) {
        if (obj.skip !== false) {
          this.defRoutes = obj.skipPath ? [obj.skipPath] : [];
        }
      }
    } catch (e) {

    }
    this.defRoutes.push({
      path: 'askQuestion',
      breadcrumbName: '我要提问'
    });
  }
}
